import type { LearnerProfile_Specialization as LearnerProfileSpecialization } from '__generated__/graphql-types-do-not-use';

import config from 'js/app/config';

import _t from 'i18n!nls/account-profile';

export const credentialType = {
  CERTIFICATE: 'CERTIFICATE',
  SPECIALIZATION: 'SPECIALIZATION',
} as const;

export type CredentialTypeValues = (typeof credentialType)[keyof typeof credentialType];

// TODO: Investigate missing partner info in some cases: https://coursera.atlassian.net/browse/LPD-477
export const getCredentialName = (credential: LearnerProfileSpecialization, type: CredentialTypeValues) => {
  if (type === credentialType.SPECIALIZATION) {
    return _t('#{credentialName} Specialization (#{partnerName})', {
      credentialName: credential.name,
      partnerName: credential.partners?.[0]?.name || '',
    });
  }
  return _t('#{partnerName} #{credentialName} Professional Certificate', {
    credentialName: credential.name,
    partnerName: credential.partners?.[0]?.name || '',
  });
};

export const getViewCertificateUrl = (credential: LearnerProfileSpecialization) => {
  return `${config.url.base}account/accomplishments/specialization/${credential.verifyCode}`;
};

/**
 * Builds an absolute URL for a badge page.
 * like https://www.coursera.org/account/accomplishments/badge/ABC123456789
 */
export const getBadgePageUrl = (badgeId: string) => {
  return `${config.url.base}account/accomplishments/badge/${badgeId}`;
};
